module.exports = __webpack_public_path__ + "static/img/arthroscopy-13.7f0c856.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-13.jpg
// module id = zmGb
// module chunks = 51